import { omit } from 'lodash';

import { SurveyType } from 'shared/types';
import {
  convertQuillHTMLToText,
  convertStringWithTagsToQuillHTML,
} from 'shared/utils';

export const getTemplatePayload = (template: SurveyType): SurveyType => {
  const data: SurveyType = {
    ...template,
    meta: omit(template.meta, template?.id ? [] : ['created_by']),
    question_details: {
      ...(template.question_details || {}),
      questions:
        template?.question_details?.questions?.map(({ id, ...q }: any) => {
          const question = { ...q, ...(template?.id ? { id } : {}) };
          question.text = convertQuillHTMLToText(question.text);
          if (q.type_info?.question_type === 'MESSAGE') {
            question.type_info.question_type = 'TEXT';
            question.type_info.meta = omit(question.type_info.meta, ['value']);
            question.type_info.meta.readOnly = true;
          }
          return question;
        }) || [],
    },
    is_template: true,
    template: true,
    channel_info: null,
  };
  return omit(data, [
    'id',
    'is_active',
    ...(template?.id
      ? []
      : [
          'updated_at',
          'created_at',
          'product_client_id',
          'is_recurring',
          'display_id',
        ]),
  ]);
};

export const getSurveyValuesFromTemplateValues = (
  payload: SurveyType,
): SurveyType => {
  const data: SurveyType = {
    ...payload,
    question_details: {
      ...payload.question_details,
      questions: payload?.question_details?.questions?.map((q: any) => ({
        ...q,
        text: convertStringWithTagsToQuillHTML(q?.text || ''),
      })),
    },
    meta: omit(payload.meta || {}, ['created_by', 'template']),
    channel_info: null,
  };
  return omit(data, [
    'updated_at',
    'id',
    'created_at',
    'is_active',
    'is_template',
    'template',
  ]);
};

export const getTemplateValues = (payload: SurveyType): SurveyType => {
  const data: SurveyType = {
    ...payload,
    question_details: {
      ...payload.question_details,
      questions: payload?.question_details?.questions?.map((q: any) => ({
        ...q,
        text: convertStringWithTagsToQuillHTML(q?.text || ''),
      })),
    },
    channel_info: null,
  };
  return data;
};
